import { forwardRef, type InputHTMLAttributes } from 'react'

import { cn } from '@/lib/utils/cn'

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        className={cn(
          'h-11 w-full rounded-lg border border-slateish-300 bg-white px-3 text-sm text-ink-700 placeholder:text-slateish-400',
          'focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500',
          'aria-[invalid=true]:border-danger-500',
          className
        )}
        {...props}
      />
    )
  }
)
